import React, { createContext, useContext, useState, useEffect } from 'react';

interface OverflowContextType {
  requestOverflowHidden: () => void;
  unsetOverflowHidden: () => void;
}

const OverflowContext = createContext<OverflowContextType | undefined>(undefined);

export const OverflowProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [overflowCount, setOverflowCount] = useState(0);

  useEffect(() => {
    if (overflowCount > 0) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [overflowCount]);

  const requestOverflowHidden = () => setOverflowCount((prev) => prev + 1);
  const unsetOverflowHidden = () => setOverflowCount((prev) => Math.max(0, prev - 1));

  return (
    <OverflowContext.Provider value={{ requestOverflowHidden, unsetOverflowHidden }}>
      {children}
    </OverflowContext.Provider>
  );
};

export const useOverflow = (): OverflowContextType => {
  const context = useContext(OverflowContext);
  if (!context) {
    throw new Error('useOverflow must be used within an OverflowProvider');
  }
  return context;
};
